import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";
import type { QuerySubscriptionOptions } from "../../../shared/api/query-subscription-options";

interface IDepartmentDto {
  createdAt: number | null;
  deletedAt: number | null;
  createdByUserId: string | null;
  farmId: string | null;
  id: string | null;
  isDeleted: boolean;
  name: string | null;
  seasonId: string | null;
  updatedAt: number | null;
  updatedByUserId: string | null;
}

export const departmentsApi = createApi({
  reducerPath: "departmentsApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchDepartmentsWithDeleted: builder.query<IDepartmentDto[], void>({
      queryFn: pagedQueryFn<IDepartmentDto, IDepartmentDto[]>(
        { url: "DepartmentsV2", params: { includeDeleted: true } },
        (dtos) => dtos
      ),
    }),
  }),
});

const useDepartmentsEndpoint =
  departmentsApi.endpoints.fetchDepartmentsWithDeleted.useQuery;

export function useFetchDepartmentsWithDeleted(
  options?: QuerySubscriptionOptions<typeof useDepartmentsEndpoint>
) {
  return useDepartmentsEndpoint(undefined, options);
}
